import { render, staticRenderFns } from "./PolicyRoles.vue?vue&type=template&id=18ae6da0"
import script from "./PolicyRoles.vue?vue&type=script&lang=js"
export * from "./PolicyRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports